<div class="start-claim-container">

  <div class="claims-progress-bar" *ngIf="currentStep<8">
    <img *ngIf="currentStep==1" src="../../../../assets/icons/crossIcon.png" alt="" (click)="crossClicked()">
    <img *ngIf="currentStep>1" src="../../../../assets/images/back-arrow.png" alt="" (click)="crossClicked()">
    <mat-progress-bar class="custom-maroon-progress" [color]="'#98282B'" [mode]="mode" [value]="value"
      [bufferValue]="bufferValue">
    </mat-progress-bar>
  </div>

  <div class="start-claim-body">
    <!-- What Happened Accident/Hospitalization/Mobile-->
    <div class="step-1" *ngIf="currentStep==1">
      <div class="start-claim-heading">
        What Happened ?
        <div class="desc">Please select the reason for your claim</div>
      </div>

      <div class="step-1-body">
        <div (click)="accidentClicked()">Accident</div>
        <div (click)="hospitalizationDueToIllnessClicked()">Hospitalization due to illness</div>
        <div (click)="mobileClaimClicked()">Mobile Claim</div>


      </div>
    </div>
    <!-- What Happened IPD/OPD/disbility/death/lop -->
    <div class="step-2" *ngIf="currentStep==2">
      <div class="start-claim-heading">
        What Happened ?
      </div>

      <div class="step-2-body" *ngIf="isAccidentClaim">
        <div (click)="ipdClicked('Accident IPD')">Hospitalization - Reimbursement</div>
        <div (click)="lossOfPayClicked()">Loss of pay</div>
        <div (click)="accidentaldeathClicked()">Accidental Death</div>
        <div (click)="opdClicked('Reimbursement OPD Accident')" *ngIf="hasOpdCover">Treatment without Admission (Outpatient)</div>

      </div>
      <div class="step-2-body" *ngIf="isHospitalizationDueToIllness">
        <!-- <div (click)="ipdClicked('Cashless IPD')" *ngIf="hasIpdCover">Hospitalization - Cashless</div> -->
        <div (click)="ipdClicked('Reimbursement IPD')" *ngIf="hasIpdCover">Hospitalization - Reimbursement
        </div>
        <!-- <div (click)="opdClicked('Reimbursement OPD')" *ngIf="hasOpdCover">Treatment without Admission (Outpatient)
        </div> -->
      </div>
    </div>
    <!-- Who was affected ? only for hopitalization + IPD/OPD -->
    <div class="step-2-5" *ngIf="currentStep==3 && (isHospitalizationDueToIllness || isAccidentClaim)">
      <div class="start-claim-heading">
        Who was affected ?
      </div>

      <div class="step-2-5-body">
        <div (click)="affectedMemberSelected(mem)" *ngFor="let mem of filteredMembers">{{mem.insuredName}}</div>
        <!-- <div (click)="affectedMemberSelected('Riya')">Riya</div> -->
      </div>
    </div>
    <div class="step-3"
      *ngIf="currentStep==4 && (isHospitalizationDueToIllness || isAccidentClaim) && !(isDeathDueToAccident || isLossOfPay || isAccidentalDeath)">
      <div class="start-claim-heading">
        We need more information to process your claim.
      </div>
      <div class="step-3-body">
        <div *ngIf="claimType === 'Reimbursement OPD'" class="claim-form-feild">
          <div class="label">Select claim category<sup>*</sup></div>
          <select ng-model="claimCategory" class="form-control" (change)="loadDocumentList($event.target.value)"
            [(ngModel)]="claimCategory">
            <option *ngFor="let category of claimCategoryList" value="{{ category.value }}">{{
              category.text
              }}</option>
          </select>
        </div>
        <div class="claim-form-feild search-box">
          <div class="label">Hospital Name*</div>
          <div class="input">
            <span class=" form-control-feedback"></span>
            <input (blur)="searchByHospitalName()" type="text" class="form-control inputText"
              placeholder="Enter Hospital Name*" (input)="HospitalNameEntered()"
              [(ngModel)]="intimateClaim.HospitalName" style="padding-right: 30px;" />
            <button type="button" class="btn btn-sm search-icon" (click)="searchByHospitalName()">
              <i>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search"
                  viewBox="0 0 16 16">
                  <path
                    d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                </svg></i>
            </button>
          </div>
          <div class="dropdown" *ngIf="hospitalSearchResults.length > 0 && isSearchDone">
            <div *ngIf="hospitalSearchResults.length > 0 && isSearchDone" class="network-hosp">Network Hospitals</div>
            <p class="text-warning" *ngIf="hospitalSearchResults.length === 0 && isSearchDone">
              Hospital name is not found in our network hospitals
            </p>
            <div class="searchresult" *ngIf="hospitalSearchResults.length > 0 && isSearchDone">
              <div class="col-md-12" *ngFor="let hospital of hospitalSearchResults" (click)="HospitalChosen(hospital)">
                <div class="claim-box" *ngIf="hospital.hospitalId === intimateClaim.HospitalId"
                  style="color: black; background-color: lightblue;">
                  <div class="media">
                    <!-- <img src="assets/images/health.png" class="mr-3" alt="Sample Image" /> -->
                    <div class="media-body">
                      <div class="mt-0 hospital-name">{{ hospital.hospitalName }}</div>
                      <p class="hospital-desc">
                        {{ hospital.address1 }}
                        {{ hospital.address2 }}
                        {{ hospital.city }}
                        {{ hospital.district }}
                        {{ hospital.state }}
                        {{ hospital.pincode }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="claim-box" *ngIf="hospital.hospitalId !== intimateClaim.HospitalId">
                  <div class="media">
                    <!-- <img src="assets/images/health.png" class="mr-3" alt="Sample Image" /> -->
                    <div class="media-body">
                      <div class="mt-0 hospital-name">{{ hospital.hospitalName }}</div>
                      <p class="hospital-desc">
                        {{ hospital.address1 }}
                        {{ hospital.address2 }}
                        {{ hospital.city }}
                        {{ hospital.district }}
                        {{ hospital.state }}
                        {{ hospital.pincode }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <!-- <div class="search-box">
          <input #searchInput type="text" [formControl]="searchCtrl" (blur)="onBlur()" (focus)="onFocus()"
            placeholder="Type to search..." autocomplete="off" />

          <button type="button" class="clear-btn" (click)="clear()" *ngIf="searchCtrl.value">
            ✕
          </button>

          <div class="dropdown" *ngIf="hospitalSearchResults.length > 0 && isSearchDone>
            <div class="loading" *ngIf="isLoading">Loading...</div>

            <div class="error" *ngIf="errorMsg">{{ errorMsg }}</div>

            <div class="item" *ngFor="let hospital of hospitalSearchResults" (mousedown)="onSelect(item)">
              {{ item.label }}
            </div>

            <div class="no-results" *ngIf="!isLoading && !errorMsg && results.length === 0">
              No results
            </div>
          </div>
        </div> -->

        <div class="claim-form-feild">
          <div class="label">Doctor's Name*</div>
          <div class="input">
            <input type="text" placeholder="Enter Doctor's Name" [(ngModel)]="intimateClaim.DoctorName"
              (input)="DoctorNameEntered()">
            <div class="errorMsg" [hidden]="doctorNameValid">
              {{ invalidDoctorNameMsg }}
            </div>
          </div>
        </div>
        <div class="claim-form-feild">
          <div class="label">Date of Admission *</div>
          <div class="input" style="position: relative;">
            <input type="date" #admissionDateInput value="{{ intimateClaim.AdmissionDate | date: 'dd MMMM yyyy' }}"
              [(ngModel)]="intimateClaim.AdmissionDate" (ngModelChange)="admissionDateChanged()"
              placeholder="Date of Admission / Consultation / Test*" type="text" class="form-control" readonly
              bsDatepicker required [minDate]="startDate" [maxDate]="endDate" [bsConfig]="{
            isAnimated: true,
            dateInputFormat: 'DD MMMM YYYY',
            adaptivePosition: true,
            containerClass: 'theme-dark-blue',
            showWeekNumbers: false

          }">
            <button class="btn btn-sm p-0 delete-btn" *ngIf="intimateClaim.AdmissionDate !== ''"
              (click)="clearAdmissionDate()">
              <span class="material-icons">delete</span>
            </button>
            <button class="btn btn-sm p-0 delete-btn" *ngIf="intimateClaim.AdmissionDate === ''"
              (click)="admissionDateInput.click()">
              <span class="material-icons">calendar_today</span>
            </button>
          </div>
        </div>
        <div class="claim-form-feild" *ngIf="claimType !== 'Reimbursement OPD'">
          <div class="label">Date of Discharge</div>
          <div class="input" style="position: relative;">
            <input type="date" #dischargeDateInput placeholder="Select Date"
              value="{{ intimateClaim.DischargeDate | date: 'dd MMMM yyyy' }}" [(ngModel)]="intimateClaim.DischargeDate"
              placeholder="Date of Discharge" type="text" class="form-control" readonly required bsDatepicker
              [minDate]="intimateClaim.AdmissionDate" [maxDate]="endDate"
              [disabled]="intimateClaim.AdmissionDate === ''" [bsConfig]="{
            isAnimated: true,
            dateInputFormat: 'DD MMMM YYYY',
            adaptivePosition: true,
            containerClass: 'theme-dark-blue',
            showWeekNumbers: false
          }">
            <button class="btn btn-sm p-0 delete-btn" *ngIf="intimateClaim.DischargeDate !== ''"
              (click)="clearDischargeDate()">
              <span class="material-icons">delete</span>
            </button>
            <button class="btn btn-sm p-0 delete-btn" *ngIf="intimateClaim.DischargeDate === ''">
              <span class="material-icons" (click)="dischargeDateInput.click()">calendar_today</span>
            </button>
          </div>
        </div>
        <div class="claim-form-feild">
          <div class="label">Claim Amount * </div>
          <div class="input">
            <input type="number" min="1" class="form-control inputText input-rupee claim-amt"
              [(ngModel)]="intimateClaim.ClaimAmount" placeholder="Claim Amount*" #ClaimAmount />
            <div class="errorMsg" *ngIf="intimateClaim.ClaimAmount <= 0">
              Claim Amount should be greater than zero.
            </div>
          </div>
        </div>
        <div class="claim-form-feild">
          <div class="label">Abha ID</div>
          <div class="input">
            <input class="form-control" placeholder="Abha ID" [(ngModel)]="intimateClaim.AbhaId"
              (input)="abhaIdEnteredForIntimation()" [maxLength]="14" />
            <div class="errorMsg" *ngIf="abhaIdAvailable && !abhaIdValid">
              {{ abhaIdInvalidMsg }}
            </div>
          </div>
        </div>
        <div class="claim-form-feild">
          <div class="label">Abha Address</div>
          <div class="input">
            <input class="form-control" placeholder="Abha Address" [(ngModel)]="intimateClaim.AbhaAddress"
              (input)="abhaAddressEnteredForIntimation()" [maxLength]="30" />

          </div>
          <div class="errorMsg " *ngIf="abhaAddressAvailable && !abhaAddressValid">
            {{ abhaAddressInvalidMsg }}
          </div>
          <div class="form-group" *ngIf="!abhaIdAvailable">
            <a href="https://www.indusindinsurance.com/insurance/abha/abhaccount.aspx" target="_blank"><u>Create your
                ABHA ID & ABHA Address</u></a>
          </div>
        </div>
        <div class="claim-form-feild is-full">
          <div class="label">What is the reason for your claim* <claim></claim>
          </div>
          <div class="input">
            <textarea maxlength="250" [(ngModel)]="intimateClaim.DiagnosisDetails"
              (input)="causeOfHospitalization($event)"
              placeholder="Briefly describe the reason for your claim (max 250 characters)"></textarea>
            <div class="text-remain">
              <span id="chars">{{ 250 - intimateClaim.DiagnosisDetails.length }}</span> characters
              remaining
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="step-3"
      *ngIf="currentStep==4 && (isAccidentClaim && (isDeathDueToAccident || isLossOfPay || isAccidentalDeath ) || isMobileClaim)">
      <div class="start-claim-heading">
        We need more information to process your claim.
      </div>
      <div class="">
        <app-gpa [intimationType]="isMobileClaim ? 'GPM' : isLossOfPay ? 'GPA' : isAccidentalDeath ? 'Accidental Death' : ''"
          (redirectToHome)="redirectToHome('fromGPA')"></app-gpa>
      </div>
    </div>
    <div class="step-4" *ngIf="currentStep==5 && !isMobileClaim">
      <div class="start-claim-heading">
        <div>
          <fieldset>
            <div class="form-card">
              <div class="rows">
                <div class="col-12 text-center custom-heading">
                  <h2 class="fs-title text-center">{{ claimType.includes('IPD') ? "Hospitalization" : "Treatment without Admission (outpatient) "}} Claim</h2>
                </div>
              </div>
              <div class="form-box scroll_class">
                <h3 class="main-heading text-left">Upload the below documentation</h3>
                <small class="text-left">Upload all available set of documents, individual file size should be less
                  than
                  5mb,
                  overall file size should be less then 30mb </small><br />

                <small class="text-left">Supported files: Jpg, jpeg, PDF, png, doc, docx, xlsx</small>
                <div name="auto-uploader" class="uplaoder-form">
                  <div class="spinner-border text-primary" *ngIf="!isClaimDocumentsLoaded">
                    <span class="sr-only">Loading...</span>
                  </div>

                  <div *ngIf="isClaimDocumentsLoaded && claimDocuments.length === 0" class="no-result-wrapper">
                    <h5>No Document to Upload</h5>
                  </div>

                  <div [hidden]="!isClaimDocumentsLoaded" class="docs-grid">
                    <div *ngFor="let doc of claimDocuments">
                      <div *ngIf="doc.isMandatory === false" class="pb-1 doc-name">{{ doc.description }} </div>
                      <div *ngIf="doc.isMandatory === true" class="pb-1 doc-name">
                        {{ doc.description }} <sup>*</sup>
                      </div>
                      <div class="upload-documentation-wrapper">

                        <!-- <input
                          type="file"
                          (change)="fileSelectionEvent($event, doc)"
                          class="form-control p-2"
                          accept="image/*"
                        /> -->
                        <div class="upload-documentation-row">
                          <div class="documentation-row-left">
                            <button class="btn px-3 btn-sm mr-2 col" [attr.id]="doc.documentId + 'upload'" type="button"
                              (click)="fileInput.click()">
                              <input #fileInput type="file" (change)="fileSelectionEvent($event, doc)"
                                style="display:none;" multiple accept=".xlsx,.jpg, .png, .doc, .docx,.pdf, .jpeg" />
                              <div>+</div>
                              <span>Upload</span>
                            </button>
                          </div>

                          <div [attr.id]="doc.documentId + 'delete'" style="display: none; width: 100%;">
                            <div class="uploaded-file-wrap">
                              <small [attr.id]="doc.documentId + 'para'" style="display: none;"
                                class="uploaded-file"></small>
                              <div>
                                <button class="btn btn-sm p-0" (click)="deleteFile(doc)">
                                  <span class="material-icons">delete</span>
                                </button>
                                <button class="btn btn-sm p-0" (click)="fileInput.click()">
                                  <span class="material-icons">edit</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="uploadImageInvalidMsg" class="delete-file-wrapper">
                          <div class="errorMsg margin-adjust" [attr.id]="doc.documentId + 'invalid'"
                            style="display: none;">
                            {{ uploadImageInvalidMsg }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <button class="btn btn-secondary previous action-button-previous mr-3" (click)="previousStep()">
              Previous
            </button>
            <button class="btn btn-primary next action-button"
              [disabled]="intimateClaimDisableNextButton || imageInvalid" (click)="step4()">
              Initiate Claim
            </button> -->
          </fieldset>
        </div>
      </div>
    </div>
    <div class="step-4" *ngIf="currentStep==5.5 && !isMobileClaim">
      <div class="start-claim-heading">
        <div>
          <fieldset>
            <div class="form-card">
              <div class="rows">
                <div class="col-12 text-center custom-heading">
                  <h2 class="fs-title text-center">{{ claimType.includes('IPD') ? "Hospitalization" : "Treatment without Admission (outpatient) "}} Claim</h2>
                </div>
              </div>
              <div class="form-box scroll_class">
                <h3 class="main-heading text-left">Uploaded Documents</h3>
                <!-- <small class="text-left">Upload all available set of documents, individual file size should be less
                  than
                  5mb,
                  overall file size should be less then 30mb </small><br /> -->

                <small class="text-left">Supported files: Jpg, jpeg, PDF, png, doc, docx, xlsx</small>
                <div name="auto-uploader" class="uplaoder-form">
                  <div class="spinner-border text-primary" *ngIf="!isClaimDocumentsLoaded">
                    <span class="sr-only">Loading...</span>
                  </div>

                  <div *ngIf="intimateClaim.DocumentList.length === 0" class="no-result-wrapper">
                    <h5>No Documents Uploaded</h5>
                  </div>

                  <div [hidden]="!isClaimDocumentsLoaded" class="docs-grid">
                    <div *ngFor="let doc of intimateClaim.DocumentList">
                      <div class="pb-1 doc-name">{{ doc.Description }}</div>
                      <div class="upload-documentation-wrapper">
                        <!-- <div *ngIf="doc.isMandatory === true" class="pb-1">
                          {{ doc.description }}<sup>*</sup> 
                        </div>-->
                        <!-- <input
                          type="file"
                          (change)="fileSelectionEvent($event, doc)"
                          class="form-control p-2"
                          accept="image/*"
                        /> -->
                        <div class="upload-documentation-row">
                          <!-- <div class="documentation-row-left">
                            <button class="btn px-3 btn-sm mr-2 col" type="button" (click)="fileInput.click()">
                              <input #fileInput type="file" (change)="fileSelectionEvent($event, doc)"
                                style="display:none;" multiple accept=".xlsx,.jpg, .png, .doc, .docx,.pdf, .jpeg" />
                              <div>+</div>
                              <span>Upload</span>
                            </button>
                          </div> -->

                          <div [attr.id]="doc.FileName + 'delete'" style="width: 100%;">
                            <div class="uploaded-file-wrap">
                              <small [attr.id]="doc.FileName + 'para'" class="uploaded-file">{{doc.FileName}}</small>
                              <!-- <button class="btn btn-sm p-0" (click)="deleteFile(doc)">
                                <span class="material-icons">delete</span>
                              </button> -->
                            </div>
                          </div>
                        </div>
                        <div class="delete-file-wrapper">
                          <div class="errorMsg margin-adjust" [attr.id]="doc.documentId + 'invalid'"
                            style="display: none;">
                            {{ uploadImageInvalidMsg }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <button class="btn btn-secondary previous action-button-previous mr-3" (click)="previousStep()">
              Previous
            </button>
            <button class="btn btn-primary next action-button"
              [disabled]="intimateClaimDisableNextButton || imageInvalid" (click)="step4()">
              Initiate Claim
            </button> -->
          </fieldset>
        </div>
      </div>
    </div>
    <div class="step-5" *ngIf="currentStep==6">
      <div class="start-claim-heading">

      </div>
      <div class="claim-details declaration">
        <app-final-declaration [name]="intimateClaim.InsuredName" [age]="intimateClaim.Age"
          [id]="intimateClaim.PolicyNumber" [uhid]="intimateClaim.UHIDNumber" [finalDeclarationDone]="isFinalDeclared"
          (isFinalDeclared)="getFinalDeclaration($event)">
        </app-final-declaration>



      </div>
    </div>


    <div class="step-5" *ngIf="currentStep==7">
      <div class="start-claim-heading">
        Who is submitting the claim request?
      </div>
      <div class="claim-details declaration">
        <div *ngIf="currentStep === 7">
          <div class="error-msg" *ngFor="let error of errorList">
            <p *ngIf="error.fieldName !== ''">{{ error.fieldName }}</p>
            <p *ngIf="error.fieldName === ''">{{ error.message }}</p>
          </div>
          <fieldset>
            <div class="form-card">
              <div class="rows">
                <div class="col-12 text-center custom-heading">
                  <h2 class="fs-title text-center">{{ claimType.includes('IPD') ? "Hospitalization" : "Treatment without Admission (outpatient) "}} Claim</h2>
                </div>
              </div>
              <div class="contact-box">
                <ul class="nav nav-tabs" style="text-align: left;">
                  <li class="nav-item text-center" [ngClass]="{ active: isIntimatorSelf }">
                    <a href="#tab1" class="nav-link" [ngClass]="{ active: isIntimatorSelf }" data-toggle="tab"
                      (click)="toggleIntimator(true)">
                      <mat-radio-group [(ngModel)]="isIntimatorSelf">
                        <mat-radio-button [value]="true" class="radio">{{ intimatorName }} (Self)</mat-radio-button>

                      </mat-radio-group>
                    </a>
                    <div class="tab-content" style="text-align: left;">
                      <div *ngIf="isIntimatorSelf">
                        <div class="form-group">
                          <label>Mobile Number</label>
                          <input type="tel" inputmode="numeric" maxlength="10"  pattern="[0-9]*" min="1" class="form-control" placeholder="Mobile Number*"
                            (input)="mobileNumberEntered()" [(ngModel)]="intimateClaim.MobileNumber" />
                        </div>
                        <div class="errorMsg margin-adjust" [hidden]="mobileNumberValid">
                          {{ invalidMobileNumberMsg }}
                        </div>

                        <div class="form-group">
                          <label>Email Address</label>
                          <input type="text" class="form-control" placeholder="Email Address*" (input)="emailEntered()"
                            [(ngModel)]="intimateClaim.EmailID" />
                        </div>
                        <div class="errorMsg margin-adjust" [hidden]="emailValid">
                          {{ invalidEmailMsg }}
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="nav-item text-center" [ngClass]="{ active: !isIntimatorSelf }">
                    <a href="#tab2" class="nav-link" [ngClass]="{ active: !isIntimatorSelf }" data-toggle="tab"
                      (click)="toggleIntimator(false)">
                      <!-- <p><i class="fa fa-user-alt"></i></p> -->
                      <mat-radio-group [(ngModel)]="isIntimatorSelf">
                        <mat-radio-button [value]="false" class="radio">Other</mat-radio-button>
                      </mat-radio-group>
                      <!-- <h4></h4> -->
                    </a>
                    <div class="tab-content" style="text-align: left;">
                      <div *ngIf="!isIntimatorSelf">
                        <div class="form-group">
                          <label>Full Name</label>
                          <input type="text" class="form-control" placeholder="Full Name"
                            (input)="intimatorNameEntered()" [(ngModel)]="intimateClaim.IntimatorName" />
                        </div>
                        <div class="errorMsg margin-adjust" [hidden]="intimatorNameValid">
                          {{ invalidIntimatorNameMsg }}
                        </div>

                        <div class="form-group">
                          <label>Mobile Number</label>
                          <input type="tel" min="1" inputmode="numeric" maxlength="10"  pattern="[0-9]*" class="form-control" placeholder="Mobile Number*"
                            (input)="intimatorMobileNumberEntered()" [(ngModel)]="intimateClaim.IntimatorMobileNo" />
                        </div>
                        <div class="errorMsg margin-adjust" [hidden]="intimatorMobileNumberValid">
                          {{ invalidIntimatorMobileNumberMsg }}
                        </div>
                        <div class="form-group">
                          <label>Relationship</label>
                          <select [(ngModel)]="selectedIntimator" class="form-control"
                            (change)="checkIsSubmitClaimTrue()" [disabled]="isHrView">
                            <option *ngFor="let member of allRelationships" [value]="member.relation">{{
                              member.relation
                              }}</option>
                          </select>
                        </div>
                        <div class="errorMsg margin-adjust" [hidden]="!selectedIntimator">
                          {{ invalidIntimatorRelationshipMessage }}
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
                <!-- <div class="tab-content">
                              <div *ngIf="isIntimatorSelf">
                                <div class="form-group">
                                  <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Mobile Number*"
                                    (input)="mobileNumberEntered()"
                                    [(ngModel)]="intimateClaim.MobileNumber"
                                  />
                                </div>
                                <div class="errorMsg margin-adjust" [hidden]="mobileNumberValid">
                                  {{ invalidMobileNumberMsg }}
                                </div>

                                <div class="form-group">
                                  <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Email Address*"
                                    (input)="emailEntered()"
                                    [(ngModel)]="intimateClaim.EmailID"
                                  />
                                </div>
                                <div class="errorMsg margin-adjust" [hidden]="emailValid">
                                  {{ invalidEmailMsg }}
                                </div>
                              </div>
                              <div *ngIf="!isIntimatorSelf">
                                <div class="form-group">
                                  <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Full Name"
                                    (input)="intimatorNameEntered()"
                                    [(ngModel)]="intimateClaim.IntimatorName"
                                  />
                                </div>
                                <div class="errorMsg margin-adjust" [hidden]="intimatorNameValid">
                                  {{ invalidIntimatorNameMsg }}
                                </div>

                                <div class="form-group">
                                  <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Mobile Number*"
                                    (input)="intimatorMobileNumberEntered()"
                                    [(ngModel)]="intimateClaim.IntimatorMobileNo"
                                  />
                                </div>
                                <div class="errorMsg margin-adjust" [hidden]="intimatorMobileNumberValid">
                                  {{ invalidIntimatorMobileNumberMsg }}
                                </div>
                                <div class="form-group">
                                  <select
                                    [(ngModel)]="selectedIntimator"
                                    class="form-control"
                                    (change)="checkIsSubmitClaimTrue()"
                                    [disabled]="isHrView"
                                  >
                                    <option *ngFor="let member of allRelationships" [value]="member.relation">{{
                                      member.relation
                                    }}</option>
                                  </select>
                                </div>
                                <div class="errorMsg margin-adjust" [hidden]="!selectedIntimator">
                                  {{ invalidIntimatorRelationshipMessage }}
                                </div>
                              </div>
                            </div> -->
              </div>
            </div>

            <div class="d-flex justify-content-center align-items-center">
              <div class="spinner-border text-primary mr-3" *ngIf="isSubmitClaim === true">
                <span class="sr-only">Submitting...</span>
              </div>

            </div>
          </fieldset>
        </div>


      </div>
    </div>


    <div class="step-5" *ngIf="currentStep==8">
      <section class="hero" aria-labelledby="hero-title">
        <h1 id="hero-title" class="title" *ngIf="isClaimNumberBlank">Duplicate claim already exists for this date of loss and selected UHID</h1>
        <p class="subtitle" *ngIf="isClaimNumberBlank || !isClaimNumberOPD">We’ll keep you updated every step of the way.</p>
        <h1 id="hero-title" class="title" *ngIf="!isClaimNumberBlank">{{ claimType.includes('IPD') ? "Hospitalization" : "Treatment without Admission (outpatient) "}} Claim Initiated</h1>
        <p class="subtitle" *ngIf="isClaimNumberOPD" style="font-size: 17px;">
          Thanks for submitting your documents, an acknowledgement would be generated within 24
          hours.</p>

        <div class="topband">
          <div class="avatar-wrap" aria-hidden="true">
            <div class="avatar">
              <img src="../../../../assets/images/assistanceBull.png" alt="Assistant avatar">
            </div>
          </div>

          <div class="contacts" aria-label="Contact information">
            <div class="contact" aria-label="Phone">
              <span class="icon" aria-hidden="true">
                <img src="../../../../assets/images/callIconCircle.png" alt="">
              </span>
              <span class="hint">+91 22 48903009</span>
            </div>

            <div class="contact" aria-label="Email">
              <span class="icon" aria-hidden="true">
                <img src="../../../../assets/images/mailIconCircle.png" alt="">
              </span>
              <span class="hint">gigclaims@indusindinsurance.com</span>
            </div>
          </div>

          <!-- <div></div> right-side spacer -->
        </div>
      </section>

      <section class="card" aria-labelledby="card-title">
        <h2 id="card-title">Claim intimation Details</h2>

        <div class="details">
          <!-- LEFT COLUMN -->
          <div class="col">
            <div class="field" *ngIf="finalDeclarationData.claimNo && !isClaimNumberOPD ">
              <span class="label">Claim No</span>
              <span class="value">{{ finalDeclarationData.claimNo }}</span>
            </div>

            <div class="field" *ngIf="finalDeclarationData.patientName">
              <span class="label">Patient Name</span>
              <span class="value">{{ finalDeclarationData.patientName}}</span>
            </div>

            <div class="field" *ngIf="finalDeclarationData.age !== undefined && finalDeclarationData.age!== null">
              <span class="label">Age</span>
              <span class="value">{{ finalDeclarationData.age }}</span>
            </div>

            <div class="field" *ngIf="intimateClaim.HospitalName">
              <span class="label">Hospital Name</span>
              <span class="value">{{ intimateClaim.HospitalName }}</span>
            </div>
          </div>

          <!-- RIGHT COLUMN -->
          <div class="col right">
            <div class="field" *ngIf="intimateClaim.PolicyNumber">
              <span class="label">Policy Number</span>
              <span class="value">{{ intimateClaim.PolicyNumber }}</span>
            </div>

            <div class="field" *ngIf="intimateClaim.UHIDNumber">
              <span class="label">UHID</span>
              <span class="value">{{ intimateClaim.UHIDNumber }}</span>
            </div>

            <div class="field" *ngIf="intimateClaim.AdmissionDate">
              <span class="label">Date Of Admission</span>
              <span class="value">{{ intimateClaim.AdmissionDate | date: dateFormat }}</span>
            </div>

            <div class="spacer-rows" aria-hidden="true"></div>
          </div>
        </div>

        <div class="bottom-pad" aria-hidden="true"></div>
      </section>


    </div>
  </div>

</div>

<div class="start-tarack-claim-wrapper vvv" *ngIf="currentStep==4 && !isMobileClaim && !isLossOfPay && !isAccidentalDeath">
  <button class="button-text" [disabled]="!hospitalNameValid ||
              !doctorNameValid ||
              intimateClaim.AdmissionDate === '' ||
              !isHospitalChosen ||
              (abhaIdAvailable && !abhaIdValid) ||
              (abhaAddressAvailable && !abhaAddressValid) ||
              !causeOfHospitalizationValid || (intimateClaim.ClaimAmount <= 0)"
    (click)="submitForm(); value = value + 10;">Continue1</button>
</div>

<div class="start-tarack-claim-wrapper" *ngIf="currentStep==5 && !isMobileClaim">
  <button class="button-text" [disabled]="intimateClaimDisableNextButton || imageInvalid"
    (click)=" currentStep=5.5; value = value + 10; trackingfn()">Continue2</button>
</div>

<div class="start-tarack-claim-wrapper" *ngIf="currentStep==5.5 && !isMobileClaim">
  <button class="button-text" [disabled]="intimateClaimDisableNextButton || imageInvalid"
    (click)="step45(); currentStep=6; value = value + 10; ">Continue3</button>
</div>

<div class="start-tarack-claim-wrapper" *ngIf="currentStep==6  && !isMobileClaim">
  <button class="button-text" [disabled]="isFinalDeclared === undefined || isFinalDeclared === 'no'"
    (click)="step5(); currentStep=7; value = value + 10;">Submit Declaration </button>
</div>

<div class="start-tarack-claim-wrapper" *ngIf="currentStep === 7">
  <button class="button-text" [disabled]="submitClaimDetails === false" (click)="step6(); value = value + 10;">Submit
    Claim </button>
</div>

<div class="start-tarack-claim-wrapper df" *ngIf="currentStep==8">
  <button class="button-text file-another-claim-button" [disabled]="intimateClaimDisableNextButton || imageInvalid"
    (click)="currentStep=1; resetSubmitClaimsVariable()">File another claim</button>
  <button class="button-text go-to-home-button" [disabled]="intimateClaimDisableNextButton || imageInvalid"
    (click)="redirectToHome('');">Go to home</button>
</div>